import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, Zap, MapPin, Calendar, Shield, Lock, CreditCard } from 'lucide-react';
export const Hero: React.FC = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-12 md:pt-20 md:pb-24 overflow-hidden" data-id="element-128">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/10 rounded-full blur-[120px] pointer-events-none" data-id="element-129" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-131">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-card border border-brand-green/30 text-brand-green font-semibold text-xs md:text-base mb-3 md:mb-6" data-id="element-132">
            🌱 TERA VENTAS ONLINE™
          </span>
        </motion.div>

        <motion.h1 className="text-4xl md:text-7xl lg:text-8xl font-black tracking-tight leading-[1.05] md:leading-[1.1] mb-3 md:mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-133">
          Todo tu año de <br className="hidden md:block" data-id="element-134" /> Nivel Inicial.
          <br data-id="element-135" />
          <span className="text-brand-green" data-id="element-136">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.p className="text-base md:text-2xl text-gray-300 font-medium mb-3 md:mb-4 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-137">
          La Agenda del Nivel Inicial — Megapack Completo.
          <br className="hidden md:block" data-id="element-138" />
          El sistema N°1 para docentes de Nivel Inicial en Argentina — 18 meses
          · 2 años · 3 años — Todas las salas.
        </motion.p>

        <motion.p className="hidden md:block text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-139">
          Planificaciones + actividades + informes listos para usar. Sin buscar.
          Sin armar. Sin perder domingos.
        </motion.p>

        {/* Product Mockup */}
        <motion.div className="relative w-full max-w-[330px] md:max-w-4xl mx-auto mb-5 md:mb-12" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/k6GhWLBSvYsXPHi9BGeKdG/9e1a433f-a531-4915-9185-46ead2d8769d.png" alt="La Agenda del Nivel Inicial — Megapack Completo: combo de 6 tomos y bonos para docentes" className="w-full h-auto mx-auto drop-shadow-[0_0_60px_rgba(34,197,94,0.25)]" data-id="element-141" />
        </motion.div>

        {/* Feature Pills */}
        <motion.div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-5 md:mb-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-142">
          {[{
          icon: <FileText size={16} data-id="element-143" />,
          text: '100% PDF'
        }, {
          icon: <Zap size={16} data-id="element-144" />,
          text: 'Acceso en 5 min'
        }, {
          icon: <MapPin size={16} data-id="element-145" />,
          text: 'Las 3 salas'
        }, {
          icon: <Calendar size={16} data-id="element-146" />,
          text: 'Todo el año'
        }].map((pill, i) => <div key={i} className="flex items-center gap-2 bg-brand-card border border-brand-card-border px-4 py-2 rounded-full text-sm font-semibold text-gray-200" data-id="element-147">
              <span className="text-brand-green" data-id="element-148">{pill.icon}</span>
              {pill.text}
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="flex flex-col items-center" data-id="element-149">
          <Button size="xl" onClick={scrollToPricing} className="mb-3 md:mb-4 !text-base md:!text-2xl !px-6 md:!px-10 !py-4 md:!py-5" data-id="element-150">
            → QUIERO MI MEGAPACK AHORA
          </Button>

          <div className="flex items-center gap-4 text-sm text-gray-400 font-medium" data-id="element-151">
            <span className="flex items-center gap-1" data-id="element-152">
              <Shield size={14} className="text-brand-green" data-id="element-153" /> Garantía 7 días
            </span>
            <span data-id="element-154">·</span>
            <span className="flex items-center gap-1" data-id="element-155">
              <Lock size={14} className="text-brand-green" data-id="element-156" /> Pago seguro
            </span>
            <span data-id="element-157">·</span>
            <span className="flex items-center gap-1" data-id="element-158">
              <CreditCard size={14} className="text-brand-green" data-id="element-159" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
};